<!-- #738: Announcement-Verwaltung. Kopfzeile -> Statusfilter -> Zeilen -> Mehr laden.
     nx-list-screen/nx-filter-bar gibt es auf 4.0.x nicht; Aufbau nach notification-delivery-list
     (#737) und issue-list.component.html. -->
<div>

  <!-- label und iconToolTip sind rohe Schluessel: pageTitle-box uebersetzt selbst
       (pageTitle-box.html:23). Eine translate-Pipe davor uebersetzte zweimal.
       Brotkrume wie auf jeder anderen Einstellungsseite — ohne sie fehlt nicht nur der Rueckweg,
       die Zeile rendert gar nicht (pageTitle-box-topline.html:3) und der Screen sitzt hoeher als
       seine Nachbarn. -->
  <nx-pageTitle-box
    [label]="'core.announcement.pageTitle.label'"
    [icon]="'icon-notification'"
    [iconToolTip]="'core.announcement.pageTitle.iconTooltip'"
    [bcRootLvlLabel]="'core.announcement.breadcrumb.settings'"
    [bcRootLvlPath]="'settings'">
    <ng-template nxTemplate="end">
      <!-- Genau EINE Aktion, deshalb ohne [menuItems]: bei nicht-leerem menuItems feuert weder
           (clicked) noch (click) (default-button.component.ts:150). -->
      <nx-default-button
        [style]="'light'"
        (click)="onCompose()"
        [label]="'core.announcement.composeAction'">
      </nx-default-button>
    </ng-template>
  </nx-pageTitle-box>

  <div class="flex flex-col lg:flex-row px-[0.75rem] py-[0.4rem] leading-[1rem] bg-white gap-2 border-t">
    <div class="flex flex-row flex-wrap gap-2 lg:flex-1">
      <!-- Werte sind exakt die Enum-Namen, AnnouncementStatus.valueOf ist case-sensitiv. Leer heisst
           „alle" und wird gar nicht mitgesendet. -->
      <nx-filter-dropdown
        [className]="'table-filter'"
        [filter]="false"
        [appendTo]="'body'"
        [showClear]="true"
        [ngModel]="status()"
        [options]="statusOptions | arrayTranslate"
        [optionValue]="'value'"
        optionLabel="label"
        [placeholder]="'core.announcement.filters.status' | translate"
        (onChange)="onStatusChange($any($event).value)"
        (onClear)="onStatusChange(null)">
      </nx-filter-dropdown>
    </div>
  </div>

  <!-- Unvollstaendiger Rueckzug. STEHEND, nicht als Toast: es gibt keinen Hintergrundjob, der
       einen abgebrochenen Durchlauf nachholt — ein erneuter Aufruf IST die Wiederaufnahme
       (Client-Dok §8.3 verlangt einen sichtbaren Hinweis, „nicht nur ein gruenes Haekchen").
       Oberhalb der Zeilen, weil er die ganze Liste betrifft und nicht eine Zeile. -->
  @if (incompleteRetraction(); as retraction) {
    <div class="bg-white border-t px-5 py-4 flex flex-row items-center gap-3">
      <div class="grow text-[14px] text-[#c0123c]">
        {{ 'core.announcement.retract.incompleteMessage' | translate:retraction }}
      </div>
      <nx-default-button
        [style]="'light'"
        [disabled]="retracting()"
        (click)="onRetryRetraction()"
        [label]="'core.announcement.retract.retryAction'">
      </nx-default-button>
      <nx-default-button
        [icon]="'icon-close'"
        [tooltip]="'core.announcement.retract.dismissAction' | translate"
        (click)="incompleteRetraction.set(null)">
      </nx-default-button>
    </div>
  }

  <!-- Pruefreihenfolge ist verbindlich: error() VOR loading(). Bei HTTP 200 + errors[] koennen beide
       gleichzeitig wahr sein — wer loading() zuerst prueft, sieht ewig einen Spinner und nie die
       Fehlerzeile. Muster notification-settings-list.component.html:8-22. -->
  @if (error()) {
    <div class="bg-white px-5 py-4 text-[#c0123c] border-t">
      {{ 'core.announcement.loadErrorMessage' | translate }}
    </div>
  } @else if (loading()) {
    <div class="bg-white px-5 py-4 flex flex-row justify-center border-t">
      <p-progressSpinner [style]="{ width: '2rem', height: '2rem' }" strokeWidth="4"></p-progressSpinner>
    </div>
  } @else if (items().length === 0) {
    <nx-empty-box
      class="border-t"
      [label]="'core.announcement.emptyMessage'">
    </nx-empty-box>
  } @else {
    <div class="border-t">
      @for (announcement of items(); track announcement.id) {
        <div
          announcement-row
          [announcement]="announcement"
          [typeLabel]="typeLabel(announcement.typeKey)"
          (cancelRequested)="onCancel($event)"
          (editRequested)="onEdit($event)"
          (retractRequested)="onRetract($event)"
          (correctRequested)="onCorrect($event)"
          (duplicateRequested)="onDuplicate($event)">
        </div>
      }
    </div>

    <!-- Keine Seitenzahlen und KEINE Gesamtzahl: die API liefert bewusst kein totalCount, und
         items().length ist keine. Das Ende der Liste sagt ausschliesslich nextCursor === null. -->
    @if (hasMore()) {
      <nx-default-button
        class="block mt-2"
        [style]="'light'"
        [width]="'full'"
        [disabled]="loadingMore()"
        (click)="loadMore()"
        [label]="loadingMore() ? 'core.announcement.loadingMore' : 'core.announcement.loadMore'">
      </nx-default-button>
    }
  }
</div>
